<template>
  <div
    class="sr-only"
    role="status"
    aria-live="polite"
    aria-atomic="true"
    data-cy="events-live-region"
  >
    {{ announcement }}
  </div>
</template>

<script setup>
import { useEventsAnnouncer } from '../../../composables/useEventsAnnouncer.js';

defineOptions({ name: 'EventsLiveRegion' });

const { announcement } = useEventsAnnouncer();
</script>

<style scoped lang="scss">
.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
</style>
